import * as React from 'react'

import {
  BottomBar,
  Container,
  ContentContainer,
  ContentMarginContainer,
  HeaderContainer,
  Logo,
} from './Footer.styles'
import FootnoteSection from './FootnoteSection'
import LinksSection from './LinksSection'

const logoUrl = 'https://ucarecdn.com/c1303c54-e765-4c61-bdc0-3922e768c490/-/format/auto/'

export default function Footer(props: { paddingBottom?: number }) {
  const { paddingBottom } = props

  return (
    <Container>
      <ContentMarginContainer>
        <ContentContainer paddingBottom={paddingBottom}>
          <HeaderContainer>
            <a href="https://www.wonderschool.com/corp">
              <Logo src={logoUrl} />
            </a>
          </HeaderContainer>
          <LinksSection />
          <FootnoteSection />
        </ContentContainer>
      </ContentMarginContainer>
      <BottomBar />
    </Container>
  )
}
